import renderSections from 'components/sections';
import styles from './general.module.scss';

// We need to add the ignoreSpacing class only if we have a section of type 'ProfessionalsHeader' or 'BreadCrumbs', since the sections after those ones
// will ignore the general spacing rule of applying margin-top.
const PageGeneral = ({ data, locale }) => (
  <>
    {data?.pageTitle ? (
      <h1 className={styles.pageTitle}>{data.pageTitle}</h1>
    ) : (
      data?.seo?.title && <h1 className="sr-only">{data.seo.title}</h1>
    )}
    {renderSections(data?.name, locale, data?.sections, styles.ignoreSpacing)}
  </>
);

export default PageGeneral;
